import addEditTourneeModele from '@/views/logistique/tourneeModele/m_tourneeModele';
import listTourneeModele from '@/views/logistique/tourneeModele/l_tourneeModele';
import listAfficheur from '@/views/commun/afficheur/l_afficheur';
import listDemande from '@/views/logistique/demande/l_demande';
import detailListeAffichage from '@/views/logistique/tourneeModele/c_tourneeModele';
import affectation from '@/views/logistique/affectation/m_affectation';
import affectationDemande from '@/views/logistique/affectation/m_affectationDemande';
import editionFournisseur from '@/views/commun/fournisseur/m_fournisseur';
import chargeTravailAff from '@/views/logistique/chargeTravail/l_chargeTravailAffichage';
import listeOrdreTravailAffichage from '@/views/logistique/ordreTravail/affichage/l_ordreTravailAffichage';
import detailOrdreTravailAffichage from '@/views/logistique/ordreTravail/affichage/c_ordreTravailAffichage';
import editionOrdreTravail from '@/views/logistique/ordreTravail/affichage/m_ordreTravailAffichage';
import detailFournisseur from '@/views/commun/fournisseur/c_fournisseur';
import listRestriction from '@/views/logistique/restriction/l_restriction';
import FaceDisponible from '@/views/logistique/faceDisponible/l_faceDisponible';
import RemplacementFaceOt from '@/views/logistique/ordreTravail/affichage/l_remplacementFaceOt';
import NglDemandeManuel from '@/components/logistique/demande/liste/ngl_demandeLogistique';
import NglDemandeAuto from '@/components/logistique/demande/liste/ngl_demandeAuto';
import AjoutFace from '@/views/logistique/tourneeModele/l_ajoutFace';
import Intervention from '@/views/logistique/intervention/m_intervention';
import listeIntervention from '@/views/logistique/intervention/l_intervention';
import listTechnicien from '@/views/commun/technicien/l_technicien';
import listeOrdreTravailTech from '@/views/logistique/ordreTravail/tech/l_ordreTravailTechnique';
import listeOrdreTravailExpedition from '@/views/logistique/ordreTravail/tech/l_otExpeditionLivraison';
import editionOrdreTravailTech from '@/views/logistique/ordreTravail/tech/m_ordreTravailTechnique';
import ajoutEmplacementDispoMatFaceOT
  from '@/views/logistique/ordreTravail/tech/ajoutEdition/ajoutEmplacementDispoMatFace';
import detailOrdreTravailTechnique from '@/views/logistique/ordreTravail/tech/c_ordreTravailTechnique';
import listeProjetLogistique from '@/views/logistique/projets/l_projets';
import editionProjet from '@/views/logistique/projets/m_projet';
import listeAffectation from '@/views/logistique/affectation/l_affectationsLogistique';
import ajoutEmplacementDispoMatFaceIntervention from '@/views/logistique/intervention/ajoutEmplacementDispoMatFace';
import ajoutDemandeIntervention
  from '@/views/logistique/ordreTravail/tech/ajoutEdition/ajoutDemandeIntervention';
import detailIntervention from '@/views/logistique/intervention/c_intervention';
import affectationLogistique from '@/views/logistique/ordreTravail/affichage/m_affectationLogistique';
import chargeTravailTech from '@/views/logistique/chargeTravail/l_chargeTravailTech';
import previsionnelDepart from '@/views/logistique/previsionnelDepart/l_previsionnelDeparts';
import previsionnelDepartCBA from '@/views/logistique/previsionnelDepart/l_previsionnelDepartsCBA';
import ajoutFaceOt from '@/views/logistique/ordreTravail/affichage/l_ajoutFaceOt';
import listeAuditTechnique from '@/views/logistique/audit/l_auditTechnique';
import addEditAuditTechnique from '@/views/logistique/audit/m_auditTechnique';
import detailAuditTechnique from '@/views/logistique/audit/c_auditTechnique';
import ajoutDispositif from '@/components/logistique/audit/addEdit/patrimoine/ajoutDispositif';
import ajoutReseau from '@/components/logistique/audit/addEdit/patrimoine/ajoutReseau';
import listeDemandeImpression from '@/views/logistique/demandeImpression/l_demandeImpression';
import detailDemandeImpression from '@/views/logistique/demandeImpression/c_demandeImpression';
import editDemandeImpression from '@/views/logistique/demandeImpression/m_demandeImpression';
import listeOrdreTravailImpression from '@/views/logistique/ordreTravail/impression/l_ordreTravailImpression';
import suiviProduction from '@/views/logistique/suiviProduction/l_suiviProduction';
import bonExpeditionDetail from '@/views/logistique/bonExpedition/c_bonExpedition';
import bonExpeditionEdit from '@/views/logistique/bonExpedition/m_bonExpedition';
import bonExpeditionList from '@/views/logistique/bonExpedition/l_bonExpedition';

export default [
  {
    path: '/ajoutAffichage',
    component: addEditTourneeModele,
    name: 'm.logistique.tournee_modele-ajout',
  },
  {
    path: '/editionAffichage/:id',
    component: addEditTourneeModele,
    name: 'm.logistique.tournee_modele-edit',
  },
  {
    path: '/listeAffichage',
    component: listTourneeModele,
    name: 'l.logistique.tournee_modele',
  },
  {
    path: '/ajoutFaceTournee',
    component: AjoutFace,
    name: 'l.logistique.tournee_modele-ajoutFace',
  },
  {
    path: '/listeDemande',
    component: listDemande,
    name: 'l.logistique.demande',
    children: [
      {
        path: 'listeDemandeAuto',
        component: NglDemandeAuto,
        name: 'l.logistique.demande-auto',
      },
      {
        path: 'listeDemandeManuel',
        component: NglDemandeManuel,
        name: 'l.logistique.demande-manuel',
      },
    ],
  },

  {
    path: '/listeAfficheur',
    component: listAfficheur,
    name: 'l.logistique.afficheur',
  },
  {
    path: '/detailListeAffichage/:id',
    component: detailListeAffichage,
    name: 'c.logistique.tournee_modele',
  },
  {
    path: '/gestionAffectation/:idCommande/:idLigneCommande',
    component: affectation,
    name: 'm.logistique.demande',
  },
  {
    path: '/gestionAffectation/:idDemande',
    component: affectationDemande,
    name: 'm.logistique.demande-manuel',
  },
  {
    path: '/ajoutFournisseur/:sousTypeFrom',
    component: editionFournisseur,
    name: 'm.logistique.afficheur',
  },
  {
    path: '/editionFournisseur/:id/:sousTypeFrom',
    component: editionFournisseur,
    name: 'm.logistique.afficheur-edition',
  },
  {
    path: '/detailFournisseur/:id/:sousTypeFrom',
    component: detailFournisseur,
    name: 'c.logistique.afficheur',
  },
  {
    path: '/chargeTravailAff',
    component: chargeTravailAff,
    name: 'l.logistique.charge_travail-affichage',
  },
  {
    path: '/chargeTravailTech',
    component: chargeTravailTech,
    name: 'l.logistique.charge_travail-tech',
  },
  {
    path: '/ordreTravail',
    component: listeOrdreTravailAffichage,
    name: 'l.logistique.ordre_travail-affichage',
  },
  {
    path: '/ordreTravail/:id',
    component: detailOrdreTravailAffichage,
    name: 'c.logistique.ordre_travail-affichage',
  },
  {
    path: '/modificationOrdreTravailAffichage/:id',
    component: editionOrdreTravail,
    name: 'm.logistique.ordre_travail-affichage',
  },
  {
    path: '/restrictionAffichage/:yearWeek',
    component: listRestriction,
    name: 'l.logistique.demande-restriction',
  },
  {
    path: '/faceDisponible/:yearWeek',
    component: FaceDisponible,
    name: 'l.logistique.demande-disponible',
  },
  {
    path: '/detailDemandeIntervention/:id',
    component: detailIntervention,
    name: 'c.logistique.demande_intervention',
  },
  {
    path: '/detailDemandeIntervention/:id/:displaySnackBar',
    component: detailIntervention,
    name: 'c.logistique.demande_intervention-displaySnackBar',
  },
  {
    path: '/editionDemandeIntervention',
    component: Intervention,
    name: 'm.logistique.demande_intervention-add',
  },
  {
    path: '/editionDemandeIntervention/:id',
    component: Intervention,
    name: 'm.logistique.demande_intervention-edition',
  },
  {
    path: '/listeIntervention',
    component: listeIntervention,
    name: 'l.logistique.demande_intervention',
  },
  {
    path: '/remplacementFaceOt',
    component: RemplacementFaceOt,
    name: 'l.logistique.ordre_travail-affichage-remplacement',
  },
  {
    path: '/ajouterFaceOt',
    component: ajoutFaceOt,
    name: 'l.logistique.ordre_travail-affichage-ajouter-face',
  },
  {
    path: '/listeTechnicien',
    component: listTechnicien,
    name: 'l.logistique.technicien',
  },
  {
    path: '/ajoutFournisseur/:sousTypeFrom',
    component: editionFournisseur,
    name: 'm.logistique.technicien',
  },
  {
    path: '/detailTechnicien/:id/:sousTypeFrom',
    component: detailFournisseur,
    name: 'c.logistique.technicien',
  },
  {
    path: '/editionFournisseur/:id/:sousTypeFrom',
    component: editionFournisseur,
    name: 'm.logistique.technicien-edition',
  },
  {
    path: '/listeOrdreTravailTech/:faceId?',
    component: listeOrdreTravailTech,
    name: 'l.logistique.ordre_travail-tech',
  },
  {
    path: '/listeOrdreTravailExpedition',
    component: listeOrdreTravailExpedition,
    name: 'l.logistique.ordre_travail_expedition',
  },
  {
    path: '/editionOrdreTravailTech/:id',
    component: editionOrdreTravailTech,
    name: 'm.logistique.ordre_travail-techEdition',
  },
  {
    path: '/addOrdreTravailTech/:patrimoineId?/:typePatrimoine?/:ligneId?',
    component: editionOrdreTravailTech,
    name: 'm.logistique.ordre_travail-techAdd',
  },
  {
    path: '/detailOrdreTravailTech/:id',
    component: detailOrdreTravailTechnique,
    name: 'c.logistique.ordre_travail-tech',
  },
  {
    path: '/addPatrimoineToOt',
    component: ajoutEmplacementDispoMatFaceOT,
    name: 'm.logistique.ordre_travail-techAddPatrimoine',
  },
  {
    path: '/addPatrimoineToDemande',
    component: ajoutEmplacementDispoMatFaceIntervention,
    name: 'm.logistique.demande_intervention-addPatrimoine',
  },
  {
    path: 'addDemandeToOt',
    component: ajoutDemandeIntervention,
    name: 'm.logistique.ordre_travail-techAddDemande',
  },
  {
    path: '/listeProjets',
    component: listeProjetLogistique,
    name: 'l.logistique.projets',
  },
  {
    path: '/editionProjet/:id',
    component: editionProjet,
    name: 'm.logistique.projets',
  },
  {
    path: '/affectationLogistique/:id',
    component: affectationLogistique,
    name: 'm.logistique.ordre_travail-affectation',
  },
  {
    path: '/listeAffectationLogistique',
    component: listeAffectation,
    name: 'l.logistique.affectation-logistique',
  },
  {
    path: '/listePrevisionnelDepart',
    component: previsionnelDepart,
    name: 'l.logistique.previsionnel-depart',
  },
  {
    path: '/listePrevisionnelDepartCBA',
    component: previsionnelDepartCBA,
    name: 'l.logistique.previsionnel-departCBA',
  },
  {
    path: '/listeAuditTechnique',
    component: listeAuditTechnique,
    name: 'l.logistique.ordre_travail_audit',
  },
  {
    path: '/addAuditTechnique',
    component: addEditAuditTechnique,
    name: 'm.logistique.ordre_travail_audit-add',
  },
  {
    path: '/editAuditTechnique/:id',
    component: addEditAuditTechnique,
    name: 'm.logistique.ordre_travail_audit-edit',
  },
  {
    path: '/detailAuditTechnique/:id',
    component: detailAuditTechnique,
    name: 'c.logistique.ordre_travail_audit',
  },
  {
    path: '/addDispositif',
    component: ajoutDispositif,
    name: 'm.logistique.ordre_travail_audit-addDispositif',
  },
  {
    path: '/addReseau',
    component: ajoutReseau,
    name: 'm.logistique.ordre_travail_audit-addReseau',
  },
  {
    path: '/editDemandeImpression/:id',
    component: editDemandeImpression,
    name: 'm.logistique.demande_impression-edit',
  },
  {
    path: '/createDemandeImpression',
    component: editDemandeImpression,
    name: 'm.logistique.demande_impression-add',
  },
  {
    path: '/detailDemandeImpression/:id',
    component: detailDemandeImpression,
    name: 'c.logistique.demande_impression',
  },
  {
    path: '/listeDemandeImpression',
    component: listeDemandeImpression,
    name: 'l.logistique.demande_impression',
  },
  {
    path: '/listeOrdreTravailImpression',
    component: listeOrdreTravailImpression,
    name: 'l.logistique.ordre_travail_impression',
  },
  {
    path: '/suiviProduction',
    component: suiviProduction,
    name: 'l.logistique.suivi_production',
  },
  {
    path: '/bonExpeditionDetail/:id',
    component: bonExpeditionDetail,
    name: 'c.logistique.bon_expedition',
  },
  {
    path: '/bonExpeditionEdit/:id',
    component: bonExpeditionEdit,
    name: 'm.logistique.bon_expedition',
  },
  {
    path: '/bonExpeditionList',
    component: bonExpeditionList,
    name: 'l.logistique.bon_expedition',
  },
];
